<div ng-controller="externalEventsGeneralController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>